export default {
  created: function () {
    window.vue = this
  },
  methods: {
    postMessageToSwift(eventName, params = '') {
      if (typeof flutterApp === 'object') {
        const json = JSON.stringify({ eventName: eventName, params: params })
        // eslint-disable-next-line no-undef
        flutterApp.postMessage(json)
      } else if (typeof window.webkit === 'undefined') {
        /* eslint-disable no-console */
        if (this.isJson(params)) {
          console.log(`${eventName}: ${JSON.parse(params)}`)
        } else {
          console.log(eventName)
        }
      } else {
        window?.webkit?.messageHandlers?.[eventName]?.postMessage(params)
      }
    },
    postMessageToSwiftWithObject(eventName, obj) {
      const json = JSON.stringify(obj)
      this.postMessageToSwift(eventName, json)
    },
    isJson(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
  },
}
